import { EditText } from '../../../../../../component/ui/edit-text/edit-text';
import { EditNumber } from '../../../../../../component/ui/edit-text/edit-number';
import { Button } from 'primereact/button';
import React, { useState } from 'react';
import { saveNewAbstractCourseOperation } from '../operations/save-new-abstract-course-operation';
import { MultiSelect } from 'primereact/multiselect';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { Major } from '../../../../../../api/types/settings/studies/major';

interface AddNewAbstractCourseDialogDataModel {
  onHide: () => any;
}
export const AddNewAbstractCourseDialog: React.FC<
  AddNewAbstractCourseDialogDataModel
> = ({ onHide }) => {
  const [courseName, setCourseName] = useState('');
  const [hoursNumber, setHoursNumber] = useState(0);
  const [percentage, setPercentage] = useState(0);
  const [loading, setLoading] = useState(false);

  const [selectedMajors, setSelectedMajors] = useState<Major[]>([]);

  const onSubmit = async () => {
    await saveNewAbstractCourseOperation(
      courseName,
      hoursNumber,
      percentage,
      selectedMajors.map((item) => item.id),
      setLoading,
      onHide,
    );
  };

  return (
    <div>
      <EditText title={'שם'} value={courseName} onChange={setCourseName} />

      <EditNumber title={'כמות שעות'} onChange={setHoursNumber} />
      <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            fontSize: '14px',
            color: '#4b5563',
            fontFamily: 'Heebo, sans-serif',
          }}
        >
          מגמות
        </div>
        <MultiSelect
          value={selectedMajors}
          onChange={(e) => setSelectedMajors(e.value)}
          options={globalSettingsStores.majors}
          optionLabel="majorName"
          placeholder="בחירת מגמה"
          maxSelectedLabels={3}
          disabled={false}
          selectedItemsLabel={`${selectedMajors.length}  פריטים נבחקו`}
          style={{
            height: '36px',
            display: 'flex',
            alignItems: 'center',
            minWidth: '250px',
            marginBottom: '16px', // Optional bottom margin for row spacing
          }}
        />
      </div>

      <EditNumber
        min={0}
        max={100}
        title={'אחוז נוכחות'}
        onChange={setPercentage}
      />

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          loading={loading}
          style={{ height: '30px' }}
          label={'שמירה'}
          onClick={onSubmit}
        />
      </div>
    </div>
  );
};
